import React, { useState, useEffect } from 'react';
import { TextField, Button, Checkbox, Container, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { useTranslation } from 'react-i18next';
import { getOrgranizationalUnits, editOrganizationUnit } from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditOrganizationalUnit = () => {
    const { t } = useTranslation('global');
    const { id } = useParams();

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [specialCategory, setSpecialCategory] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch organizational units
                const units = await getOrgranizationalUnits();
                const unit = units.find(e => e.id.toString() === id);
                if(unit){
                    setName(unit.name);
                    const isSpecialCategory = Boolean(unit.special_category);
                    setSpecialCategory(isSpecialCategory);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!name) {
            setErrMsg(t("editOrganizationUnit.requiredFields"));
            return;
        }

        const updatedOrganizationUnit = {
            id,
            name,
            special_category: specialCategory ? 1 : 0
        };

        try {
            const response = await editOrganizationUnit(updatedOrganizationUnit);
            if (response.success) {
                setSucc(t("editOrganizationUnit.successfullyUpdated"));
                setTimeout(() => setSucc(''), 3000);
            } else {
                setErrMsg(t("editOrganizationUnit.updateFailed"));
                setTimeout(() => setErrMsg(''), 3000);
            }
        } catch (error) {
            setErrMsg(t("editOrganizationUnit.updateFailed"));
            setTimeout(() => setErrMsg(''), 3000);
        }
    };

    return (
        <Container maxWidth="sm" className="container-employee" sx={{ p: 3, flexShrink: 0, mt: 4 }} >
            <Typography variant="h4" sx={{ mb:4 }}>{t("editOrganizationUnit.editOrganizationUnit")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
                <Grid container spacing={2}>
                    {/* Organization Unit ID - disabled */}
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label={t("newOrganizationUnit.id")}
                            fullWidth
                            value={id}
                            required
                            disabled
                        />
                    </Grid>
                    
                    {/* Organization unit name */}
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label={t("newOrganizationUnit.name")}
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Grid>
                    
                    {/* Special category Checkbox */}
                    <Grid item xs={12}>
                        <FormControlLabel
                            label={t("newOrganizationUnit.specialCategory")}
                            control={
                                <Checkbox
                                    checked={specialCategory}
                                    onChange={(e) => setSpecialCategory(e.target.checked)}
                                    value={specialCategory}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button fullWidth variant="contained" type="submit">{t("edit.save")}</Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                                              <Button
                                                fullWidth
                                                type="button"
                                                variant="contained"
                                                color="error"
                                                onClick={() => { navigate('/new-organization-unit') }}
                                              >
                                                {t("editReader.cancel")}
                                              </Button>
                                            </Grid>
                </Grid>
            </form>

            {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
            {succ && <Success message={succ} onClose={() => setSucc('')} />}
        </Container>
    );
};

export default EditOrganizationalUnit;
